import { z } from 'zod';
import { isoDate, oneOfNumbers } from '../../../navigation/searchParams';
import { PERIOD_PRESETS } from './usagePeriod';

type PresetDays = (typeof PERIOD_PRESETS)[number]['days'];

/** The preset lengths the period picker offers, so the address takes exactly those. */
const PRESET_DAYS = PERIOD_PRESETS.map((p) => p.days) as unknown as readonly [PresetDays, ...PresetDays[]];

/**
 * The period a page shows (the Dashboard, and Livepoint's usage pages): a
 * preset number of days (the PERIOD_PRESETS in usagePeriod.ts) or a custom
 * `from`/`to` range of UK days. Livepoint's tenant list and a tenant's page
 * share it, so the trail back keeps it.
 */
export const periodSearch = z.object({
  period: oneOfNumbers(PRESET_DAYS),
  from: isoDate,
  to: isoDate,
});
